export class Commitment {
    constructor(
        public projectId: string,
        public fieldInspector: string,
        public companyName: string,
        public commitmentType: string,
      ) {}
}
